// eslint-disable-next-line no-restricted-imports
import { useTheme } from '@emotion/react';
import { Box } from '@iheartjane/reefer';
import type { AppMode } from '@iheartjane/types';
import { useNavigate } from 'react-router';

import { useMoengage } from '@jane/shared-ecomm/tracking';
import { useEcommApp } from '@jane/shared/providers';
import { monolithPaths as paths } from '@jane/shared/util';

import { useCustomerDispatch } from '../../customer/dispatch';
import { closeModal } from '../../customer/redux/application';
import { replaceCart, selectCart } from '../../customer/redux/cart';
import { useCustomerSelector } from '../../customer/selectors';
import { Modal } from '../modal';
import { ReplaceCartContents } from './contents';

export const ReplaceCart = () => {
  const { moeTrack } = useMoengage();
  const theme = useTheme();
  const dispatch = useCustomerDispatch();
  const navigate = useNavigate();
  const { appMode } = useEcommApp();
  const { replacementCart } = useCustomerSelector(selectCart);

  const goToNextPath = (appMode: AppMode) => {
    if (appMode === 'default') {
      return dispatch(closeModal());
    }

    return navigate(paths.embeddedMenu());
  };

  const onReplaceCart = () => {
    if (!replacementCart) {
      return;
    }
    dispatch(replaceCart(replacementCart, moeTrack));
    goToNextPath(appMode);
  };

  if (appMode === 'default') {
    return (
      <div>
        <Modal
          contentLabel="Clear bag"
          // eslint-disable-next-line react/forbid-component-props -- legacy emotion
          css={{ borderRadius: theme?.borderRadius.sm }}
          width="small"
        >
          {(closeModal: () => void) => (
            <ReplaceCartContents
              onCancel={closeModal}
              onReplaceCart={onReplaceCart}
            />
          )}
        </Modal>
      </div>
    );
  }

  return (
    <Box mx="auto" maxWidth={360} pt={24}>
      <ReplaceCartContents
        onCancel={() => replacementCart && goToNextPath(appMode)}
        onReplaceCart={onReplaceCart}
      />
    </Box>
  );
};
